import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Quiz from './views/Quiz';
import LikertQuiz from './views/LikertQuiz';
import Result from './views/Result';
import LikertResult from './views/LikertResult';
import Typography from '@material-ui/core/Typography';
import WarningIcon from '@material-ui/icons/Warning';
import Header from './components/Header';
import LikertManagementPolarities from './views/LikertManagementPolarities';
import LikertManagementPolaritiesResult from './views/LikertManagementPolaritiesResult';

import { ThemeProvider, createMuiTheme } from '@material-ui/core/styles';
 
const theme = createMuiTheme({
	typography: {
	  fontFamily: 'Roboto',
	}
});

function App() {
    return (
		<ThemeProvider theme={theme}>
			<BrowserRouter>
				<div>
					<Switch>
						<Route exact path="/" component={Quiz} />
						<Route path="/result/:id" component={Result} />
						<Route exact path="/quiz" component={LikertQuiz} />
						<Route exact path="/quiz/result/:id" component={LikertResult} />
						<Route exact path="/management_polarities" component={LikertManagementPolarities} />
						<Route exact path="/management_polarities/result/:id" component={LikertManagementPolaritiesResult} />

						<Route path="*">
							<>
								<Header />
								<Typography variant="h4" style={{ marginTop: '50px', textAlign: 'center' }}>
									<WarningIcon color="secondary" fontSize="large" style={{ position: 'relative', top: '5px', marginRight: '5px' }} />
									Page not found
								</Typography>
							</>
						</Route>
					</Switch>
				</div>
			</BrowserRouter>

		</ThemeProvider>
    );
}
export default App;
